const createIframe = (src) => {
  const iframeElement = document.createElement('iframe');
  iframeElement.src = src;
  iframeElement.width = '100%';
  iframeElement.height = '100%';
  iframeElement.setAttribute('frameborder', '0');

  return iframeElement;
};

export default createIframe;
